export default __webpack_public_path__ + "assets/5bdd0e4149a803383686aa2c46b6238e.mp4";